import React, { ReactElement } from 'react';
import ChampFormulaire from '../../Common/ChampFormulaire';
import { LABEL_COL } from '../constantes';
import { MyPaper } from '../Utils/MyPaper';

interface ChampsEtiquetteCategorieProps {
    categorieId?: string;
}

export function ChampsEtiquetteCategorie({ categorieId }: ChampsEtiquetteCategorieProps): ReactElement {
    return (
        <MyPaper>
            <ChampFormulaire estPetit labelCol={LABEL_COL} id="name" titre="Nom" />
            <ChampFormulaire estPetit labelCol={LABEL_COL} id="description" titre="Description" textarea />

            <input name="categorie_id" id="categorie_id" type="hidden" value={categorieId} />
        </MyPaper>
    );
}
